export const siteTitle = 'UniSMS 合一短信'

export const UVI_CACHE_KEY = 'uni_uvi'
